export enum NotificationType {
  Mention = "Mention",
  Success = "Success",
  Error = "Error",
}
